import styled from 'styled-components';
import Form from 'components/form';
import { color, typography } from 'styles/settings';

export const NameInput = styled(Form.TextInput)`
  display: block;
  width: 90%;
  margin: 0 auto;
  padding: 0;
  max-width: none;
  ${typography.font.title.bold};
  font-size: ${typography.size.xxxl};
  height: 81px;
  text-align: center;
  background-color: transparent;
`;

export const SurfaceWrapper = styled.div`
  position: relative;
  width: 80%;
  height: 400px;
  background-color: ${color.neutral.grayLighter};
  border-radius: 100%;
  top: calc(50% - 200px - 45px);
  margin: 0 auto;
  overflow: hidden;
  text-align: center;

  > * {
    width: 100%;
    text-align: center;
    position: relative;
    display: block;
    top: calc(50% - 40px);
    margin: 0 auto;
  }
`;
